import BookingDialog from '@/components/dialogs/BookingDialog';
import CleaningDialog from '@/components/dialogs/CleaningDialog';
import MaintenanceDialog from '@/components/dialogs/MaintenanceDialog';
import OwnerUseDialog from '@/components/dialogs/OwnerUseDialog';
import RenovationDialog from '@/components/dialogs/RenovationDialog';
import EventDetailsDialog from '@/components/dialogs/EventDetailsDialog';

/**
 * CalendarDialogs — cluster of "add / edit" dialogs conditionally
 * mounted based on `dialogType`, plus the always-mounted
 * EventDetailsDialog. Extracted from CalendarView to keep the parent
 * lean and to make the dialog wiring diff'able in isolation.
 */
export const CalendarDialogs = ({
  dialogType,
  onClose,
  selectedDate,
  editingItem,
  properties,
  selectedProperty,
  detailEvent,
  onDetailClose,
  onEditEvent,
}) => (
  <>
    <BookingDialog
      open={dialogType === 'booking'}
      onClose={onClose}
      selectedDate={selectedDate}
      properties={properties}
      selectedProperty={selectedProperty}
      editingBooking={editingItem}
    />
    <OwnerUseDialog
      open={dialogType === 'owner_use'}
      onClose={onClose}
      selectedDate={selectedDate}
      properties={properties}
      selectedProperty={selectedProperty}
      editingBooking={editingItem}
    />
    <CleaningDialog
      open={dialogType === 'cleaning'}
      onClose={onClose}
      selectedDate={selectedDate}
      properties={properties}
      selectedProperty={selectedProperty}
      editingTask={editingItem}
    />
    <MaintenanceDialog
      open={dialogType === 'maintenance'}
      onClose={onClose}
      selectedDate={selectedDate}
      properties={properties}
      selectedProperty={selectedProperty}
      defaultCategory="general"
      editingTask={editingItem}
    />
    <MaintenanceDialog
      open={dialogType === 'landscaping'}
      onClose={onClose}
      selectedDate={selectedDate}
      properties={properties}
      selectedProperty={selectedProperty}
      defaultCategory="landscaping"
      editingTask={editingItem}
    />
    <RenovationDialog
      open={dialogType === 'renovation'}
      onClose={onClose}
      selectedDate={selectedDate}
      properties={properties}
      selectedProperty={selectedProperty}
      editingProject={editingItem}
    />

    <EventDetailsDialog
      open={!!detailEvent}
      event={detailEvent}
      properties={properties}
      onClose={onDetailClose}
      onEdit={onEditEvent}
    />
  </>
);

export default CalendarDialogs;
